<template>
  <div>
    <pt-collapsible-sidebar
      ref="collapsibleSidebarRight"
      :width="1080"
      :overlay="true"
      :partial-collapse="false"
      position="right"
      class="approval-sidebar"
    >
      <div v-if="details && details.entity_type" slot="expanded" class="flex flex-col h-full">
        <div class="mx-5 flex-grow">
          <header class="border-b flex flex-row items-center py-4">
            <span class="cursor-pointer mt-1" @click="toggle">
              <i class="fa fa-arrow-left mr-4 mb-1" aria-hidden="true" />
            </span>
          </header>
        </div>

        <div class="flex flex-col flex-grow mt-4 justify-between overflow-y-auto content mx-5 border-b">
          <div class="border rounded">
            <div class="flex items-center px-2 py-4 border-b">
              <div class="text-grey-darker font-bold mr-2">Type of change:</div>
              <div :class="`text-${typeOfChange} text-sm capitalize font-bold`">
                {{ details.type_of_change }}
              </div>
            </div>
            <div class="flex px-2 py-4 border-b">
              <div class="flex flex-col">
                <p class="text-grey-darker font-bold mb-2">Name</p>
                <div v-if="isSingleName && upcomingName && isTypeUpdate" class="flex flex-col">
                  <p class="font-bold">Updated: {{ upcomingName }}</p>
                </div>
                <div v-else-if="isSingleName" class="flex flex-col">
                  <p class="font-bold">{{ upcomingName || currentName }}</p>
                </div>
                <div v-else class="flex flex-col">
                  <p class="text-grey-darker font-bold mb-2">Previous: {{ currentName }}</p>
                  <p class="font-bold">Updated: {{ upcomingName }}</p>
                </div>
              </div>
            </div>
            <div v-if="isTypeItem && isDescriptionExist" class="flex flex-col px-2 py-4 border-b">
              <p class="text-grey-darker font-bold mb-2">Description</p>
              <div v-if="isSingleItemDescription && upcomingItemDescription && isTypeUpdate" class="flex flex-col">
                <p class="font-bold">Updated: {{ upcomingItemDescription }}</p>
              </div>
              <div v-else-if="(isSingleItemDescription && (upcomingItemDescription !== null))" class="flex flex-col">
                <p class="font-bold">{{ upcomingItemDescription || currentItemDescription }}</p>
              </div>
              <div v-else class="flex flex-col">
                <p class="text-grey-darker font-bold mb-2">Previous: {{ currentItemDescription }}</p>
                <p class="font-bold">Updated: {{ upcomingItemDescription }}</p>
              </div>
            </div>
            <div v-if="isTypeItem" class="flex flex-col px-2 py-4 border-b">
              <p class="text-grey-darker font-bold mb-2">Category Name</p>
              <div v-if="isSingleCategoryName && upcomingCategoryName && isTypeUpdate" class="flex flex-col">
                <p class="font-bold">Updated: {{ upcomingCategoryName }}</p>
              </div>
              <div v-else-if="isSingleCategoryName" class="flex flex-col">
                <p class="font-bold">{{ upcomingCategoryName || currentCategoryName }}</p>
              </div>
              <div v-else class="flex flex-col">
                <p class="text-grey-darker font-bold mb-2">Previous: {{ currentCategoryName }}</p>
                <p class="font-bold">Updated: {{ upcomingCategoryName }}</p>
              </div>
            </div>
            <div v-if="isTypeItem" class="flex flex-col px-2 py-4 border-b">
              <p class="text-grey-darker font-bold mb-2">Price</p>
              <div v-if="isSingleItemPrice && upcomingItemPrice && isTypeUpdate" class="flex flex-col">
                <p class="font-bold">
                  Updated:
                  <i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" />
                  <span v-else>रू</span>
                  {{ upcomingItemPrice }}
                </p>
              </div>
              <div v-else-if="isSingleItemPrice" class="flex flex-col">
                <p class="font-bold">
                  <i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" /> <span v-else>रू</span>
                  {{ upcomingItemPrice || currentItemPrice }}
                </p>
              </div>
              <div v-else class="flex flex-col">
                <p class="text-grey-darker font-bold mb-2">
                  Previous: <i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" /> <span v-else>रू</span>
                  {{ currentItemPrice }}
                </p>
                <p class="font-bold">
                  Updated: <i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" /> <span v-else>रू</span>
                  {{ upcomingItemPrice }}
                </p>
              </div>
            </div>
            <div v-if="isTypeItem" class="flex flex-col px-2 py-4 border-b">
              <p class="text-grey-darker font-bold mb-2">Menu Hours</p>
              <div v-if="isSingleMenuHourName && upcomingMenuHourName && isTypeUpdate" class="flex flex-col">
                <p class="font-bold">Updated: {{ upcomingMenuHourName }}</p>
              </div>
              <div v-else-if="isSingleMenuHourName" class="flex flex-col">
                <p class="font-bold">{{ upcomingMenuHourName || currentMenuHourName }}</p>
              </div>
              <div v-else class="flex flex-col">
                <p class="text-grey-darker font-bold mb-2">Previous: {{ currentMenuHourName }}</p>
                <p class="font-bold">Updated: {{ upcomingMenuHourName }}</p>
              </div>
            </div>

            <div v-if="isTypeItem && upcomingImage && isImageExist" class="flex flex-col px-2 py-4 border-b">
              <p class="text-grey-darker font-bold mb-2">Image</p>
              <div v-if="isSingleImage && upcomingImage && isTypeUpdate" class="flex flex-col">
                <p class="font-bold">Updated:</p>
                <div class="w-2/3 md:w-1/3 md:w-auto">
                  <div class="item-img-container">
                    <img :src="upcomingImage" alt="Item Image" />
                  </div>
                </div>
              </div>
              <div v-else-if="isSingleImage" class="flex flex-col">
                <div class="w-2/3 md:w-1/3 md:w-auto">
                  <div class="item-img-container">
                    <img :src="upcomingImage || currentImage" alt="Item Image" />
                  </div>
                </div>
              </div>
              <div v-else class="flex flex-col">
                <div class="mb-4">
                  <p class="text-grey-darker font-bold mb-2">Previous:</p>
                  <div class="w-2/3 md:w-1/3 md:w-auto">
                    <div class="item-img-container">
                      <img :src="currentImage" alt="Item Image" />
                    </div>
                  </div>
                </div>
                <div>
                  <p class="text-grey-darker font-bold mb-2">Updated:</p>
                  <div class="w-2/3 md:w-1/3 md:w-auto">
                    <div class="item-img-container">
                      <img :src="upcomingImage" alt="Item Image" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mx-5 mt-2 py-4 flex-grow">
          <pt-button
            class="ml-1 secondary-outline-button secondary-outline-button-dark-grey"
            variant="secondary-outline"
            size="sm"
            @action="toggle"
          >
            <p class="sidebar-cancel-button">Close</p>
          </pt-button>
        </div>
      </div>
    </pt-collapsible-sidebar>
  </div>
</template>

<script>
import { PtCollapsibleSidebar } from '@pathao/ui-components/esm/SidebarV1';
import isBDPhoneNumber from '@src/utils/isBdNumber';
// import capitalizeFirstLetter from '@utils/capitalize-first-letter';

export default {
  name: 'ApprovalChanges',
  components: {
    PtCollapsibleSidebar,
  },
  props: {
    details: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      upcomingChanges: (this.details && this.details.changes.upcoming) || {},
      currentChanges: (this.details && this.details.changes.current) || {},
    };
  },
  computed: {
    isTypeItem() {
      return this.details.entity_type === 'item';
    },
    isTypeUpdate() {
      return this.details.type_of_change === 'update';
    },
    upcomingName() {
      return (this.upcomingChanges && this.upcomingChanges.name) || undefined;
    },
    currentName() {
      return (this.currentChanges && this.currentChanges.name) || undefined;
    },
    isSingleName() {
      return this.isUndefinedOrEmpty(this.upcomingName) || this.isUndefinedOrEmpty(this.currentName);
    },
    upcomingItemDescription() {
      if (this.upcomingChanges) {
        if (this.upcomingChanges.description === null) {
          return null;
        }
        return this.upcomingChanges.description || undefined;
      }
    },
    currentItemDescription() {
      if (this.currentChanges) {
        if (this.currentChanges.description === null) {
          return null;
        }
        return this.currentChanges.description || undefined;
      }
    },
    isDescriptionExist() {
      return (
        !this.isUndefinedOrEmpty(this.upcomingItemDescription) ||
        !this.isUndefinedOrEmpty(this.currentItemDescription)
      );
    },
    isSingleItemDescription() {
      return (
        this.isUndefinedOrEmpty(this.upcomingItemDescription) ||
        this.isUndefinedOrEmpty(this.currentItemDescription)
      );
    },
    upcomingCategoryName() {
      return (this.upcomingChanges && this.upcomingChanges.category_name) || undefined;
    },
    currentCategoryName() {
      return (this.currentChanges && this.currentChanges.category_name) || undefined;
    },
    isSingleCategoryName() {
      return (
        this.isUndefinedOrEmpty(this.upcomingCategoryName) ||
        this.isUndefinedOrEmpty(this.currentCategoryName)
      );
    },
    upcomingItemPrice() {
      return (this.upcomingChanges && this.upcomingChanges.price) || undefined;
    },
    currentItemPrice() {
      return (this.currentChanges && this.currentChanges.price) || undefined;
    },
    isSingleItemPrice() {
      return (
        this.isUndefinedOrEmpty(this.upcomingItemPrice) || this.isUndefinedOrEmpty(this.currentItemPrice)
      );
    },
    upcomingMenuHourName() {
      return (this.upcomingChanges && this.upcomingChanges.menu_hour_name) || undefined;
    },
    currentMenuHourName() {
      return (this.currentChanges && this.currentChanges.menu_hour_name) || undefined;
    },
    isSingleMenuHourName() {
      return (
        this.isUndefinedOrEmpty(this.upcomingMenuHourName) ||
        this.isUndefinedOrEmpty(this.currentMenuHourName)
      );
    },
    upcomingImage() {
      return (this.upcomingChanges && this.upcomingChanges.image) || undefined;
    },
    currentImage() {
      return (this.currentChanges && this.currentChanges.image) || undefined;
    },
    isImageExist() {
      return !this.isUndefinedOrEmpty(this.upcomingImage) || !this.isUndefinedOrEmpty(this.currentImage);
    },
    isSingleImage() {
      return this.isUndefinedOrEmpty(this.upcomingImage) || this.isUndefinedOrEmpty(this.currentImage);
    },
    typeOfChange() {
      const type = this.details.type_of_change;
      return type === 'add' ? 'green' : type === 'update' ? 'orange' : 'red';
    },
  },
  watch: {
    details(newValue) {
      this.upcomingChanges = newValue.changes.upcoming || {};
      this.currentChanges = newValue.changes.current || {};
    },
  },
  methods: {
    isBDPhoneNumber,
    isUndefinedOrEmpty(value) {
      return value === undefined || value === '';
    },
    toggle() {
      this.$refs.collapsibleSidebarRight.toggle();
    },
  },
};
</script>
